import {
  ToitEnPenteConfigurationState,
  ToitEnPenteThermalPerformanceState,
  initialToitEnPenteConfigurationState,
  initialToitEnPenteThermalPerformanceState
} from "@iko-design-center/shared"
import { DownloadState, initialDownloadState } from "./download"

export type ToitEnPenteState = {
  configuration: ToitEnPenteConfigurationState
  download: DownloadState
  thermalPerformance: ToitEnPenteThermalPerformanceState
  screenshots: string[]
  overviewScreenshot: string | null
}

export const initialToitEnPenteState: ToitEnPenteState = {
  configuration: initialToitEnPenteConfigurationState,
  download: initialDownloadState,
  thermalPerformance: initialToitEnPenteThermalPerformanceState,
  screenshots: [],
  overviewScreenshot: null,
}
